'use client';

import type { JSX } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from '@/config/queryClient';

type ReactQueryProviderProps = {
    children: React.ReactNode;
};

export default function ReactQueryProvider({ children }: ReactQueryProviderProps): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <QueryClientProvider client={queryClient}>
            {children}

            {/* React Query Dev Tools */}
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
}
